module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/6-370095ef254f722519ce2648fe8e6ea6.jpg";